import React from 'react';
import './Button.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const STYLES = ['btn--primary', 'btn--outline', 'btn--test', 'btn--book', 'btn--secondary'];
const SIZES = ['btn--medium', 'btn--large'];

export const Button = ({
  children,
  type,
  onClick,
  buttonStyle,
  buttonSize,
  navigate
}) => {
  const checkButtonStyle = STYLES.includes(buttonStyle)
    ? buttonStyle
    : STYLES[0];

  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

  const navigateTo = useNavigate();

  const handleClick = (event) => {
    if (onClick) onClick(event);
    if (navigate) navigateTo(navigate);
  };

  return (
      <button
        className={`btn ${checkButtonStyle} ${checkButtonSize} btn-mobile`}
        onClick={handleClick}
        type={type}
      >
        {children}
      </button>
  );
};